/* eslint-disable max-lines-per-function */
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import createMuiTheme from '@material-ui/core/styles/createTheme';
import PropTypes from 'prop-types';
import React from 'react';
import locale from '../locale/Localization';

const theme = createMuiTheme();
const styles = {
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  inputLabel: {
    width: 300
  },
  select: {
    width: 250,
    marginTop: 24
  }
};

/**

 * Notary contract field.
 * @param {P} props the props.
 * @return {*} the rendered string.
 */
export default function NotarizedTypeInput(props) {
  const getReadOnlyOptions = () => {
    return (
      <React.Fragment>
        <option value='other'>{locale.other}</option>
        <option value='land'>{locale.land}</option>
        <option value='will'>{locale.will}</option>
        <option value='commercial'>{locale.commercial}</option>
      </React.Fragment>
    );
  };
  return (
    <FormControl style={styles.formControl}>
      <InputLabel htmlFor='notarized-type' style={styles.inputLabel}>
        {locale.notarizedType}
      </InputLabel>
      <Select
        disabled={props.disabled}
        native
        id='notarized-type'
        name='notarizedType'
        value={props.notarizedType}
        onChange={(event) => {
          props.handleFieldChange(event);
        }}
        style={styles.select}
        inputProps={{
          id: 'notarized-type'
        }}
      >
        {/* TODO add real values */}
        <option value='' />
        {props.contract === 'contractAmongLiving' && (
          <option value='guarantee'>{locale.guarantee}</option>
        )}
        {props.contract === 'contractAmongLiving' && (
          <option value='marriageLaw'>{locale.marriageLaw}</option>
        )}
        {props.contract === 'contractByDead' && (
          <option value='lawOfSuccession'>{locale.lawOfSuccession}</option>
        )}
        {props.contract === 'contractAmongLiving' && (
          <option value='familyInheritanceLaw'>
            {locale.familyInheritanceLaw}
          </option>
        )}
        {props.contract === 'contractAmongLiving' && (
          <option value='familyLaw'>{locale.familyLaw}</option>
        )}
        {props.contract === 'contractByDead+contractAmongLiving' && (
          <option value='familyAndSoccessionLaw'>
            {locale.familyAndSoccessionLaw}
          </option>
        )}
        {props.contract === 'contractAmongLiving' && (
          <option value='commercialLaw'>{locale.commercialLaw}</option>
        )}
        {props.contract === 'contractAmongLiving' && (
          <option value='propertyLaw'>{locale.propertyLaw}</option>
        )}
        {props.contract === 'contractAmongLiving' && (
          <option value='foundationLaw'>{locale.foundationLaw}</option>
        )}
        {props.contract === 'contractAmongLiving' && (
          <option value='securitiesLaw'>{locale.securitiesLaw}</option>
        )}
        {props.contract === 'authentication' && (
          <option value='authenticationOfCopy'>
            {locale.authenticationOfCopy}
          </option>
        )}
        {props.contract === 'authentication' && (
          <option value='authenticationOfSignature'>
            {locale.authenticationOfSignature}
          </option>
        )}
        {props.contract === 'authentication' && (
          <option value='authenticationOfDate'>
            {locale.authenticationOfDate}
          </option>
        )}
        {props.disabled && getReadOnlyOptions()}
      </Select>
    </FormControl>
  );
}

NotarizedTypeInput.propTypes = {
  handleFieldChange: PropTypes.func,
  contract: PropTypes.string,
  notarizedType: PropTypes.string,
  disabled: PropTypes.bool
};
